import { useEffect, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { obtenerListaPersona } from "../api/api-persona";
import {
    MENSAJE_ACCION_KANBAN_MAX_LENGTH,
    normalizarConfigAccionesKanban,
} from "../api/api-kanban-config";
import {
    ESTILO_BOTON_MODAL_ACEPTAR,
    ESTILO_BOTON_MODAL_CANCELAR,
    ESTILO_INPUT_GENERICO,
} from "../utils/const/estilos-const";

export default function ModalConfigAccionesSolicitudKanban({
    isOpen,
    initialConfig,
    onCancel,
    onSave,
}) {
    const { t } = useTranslation();
    const [listaPersonas, setListaPersonas] = useState([]);
    const [cargandoPersonas, setCargandoPersonas] = useState(false);
    const [config, setConfig] = useState(normalizarConfigAccionesKanban(initialConfig));

    useEffect(() => {
        if (!isOpen) return;
        setConfig(normalizarConfigAccionesKanban(initialConfig));

        const cargarOpciones = async () => {
            setCargandoPersonas(true);
            const personas = await obtenerListaPersona({ habilitado: 1 }, true);
            setListaPersonas(Array.isArray(personas) ? personas : []);
            setCargandoPersonas(false);
        };
        cargarOpciones();
    }, [isOpen, initialConfig, t]);

    if (!isOpen) return null;

    const updateAction = (action, field, value) => {
        setConfig((prev) => ({
            ...prev,
            [action]: {
                ...prev[action],
                [field]: value,
            },
        }));
    };

    const selectStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
    };

    const renderNotificacionFields = (action) => (
        <>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("label_mensaje_notificacion")}
            </label>
            <textarea
                className={`${ESTILO_INPUT_GENERICO} min-h-[90px]`}
                maxLength={MENSAJE_ACCION_KANBAN_MAX_LENGTH}
                value={config[action].mensaje}
                onChange={(event) =>
                    updateAction(action, "mensaje", event.target.value)
                }
                placeholder={t("placeholder_mensaje_notificacion_rechazo")}
            />
            <p className="text-xs text-right text-gray-500 mt-1">
                {config[action].mensaje.length}/{MENSAJE_ACCION_KANBAN_MAX_LENGTH}
            </p>

            <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">
                {t("label_notificar_a")}
            </label>
            <Select
                options={listaPersonas}
                isMulti
                isSearchable
                isClearable
                isLoading={cargandoPersonas}
                value={config[action].notificarA}
                onChange={(options) =>
                    updateAction(action, "notificarA", options || [])
                }
                placeholder={t("placeholder_seleccione_persona")}
                classNamePrefix="react-select"
                menuPortalTarget={document.body}
                styles={selectStyles}
            />
        </>
    );

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="fixed inset-0 bg-gray-500 opacity-75" onClick={onCancel} />
            <div className="relative z-50 bg-white w-11/12 md:max-w-2xl max-h-[90vh] overflow-y-auto rounded-lg shadow-xl">
                <div className="p-6">
                    <h3 className="text-lg font-semibold text-gray-900">
                        {t("label_configurar_acciones_solicitud")}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1 mb-4">
                        {t("label_configurar_acciones_solicitud_desc")}
                    </p>

                    <div className="space-y-4">
                        <div className="border rounded-lg p-3 border-green-200 bg-green-50/50 text-green-800">
                            <p className="text-sm font-semibold mb-3">
                                {t("label_accion_aceptar_ok")}
                            </p>
                            {renderNotificacionFields("aceptar")}
                        </div>

                        <div className="border rounded-lg p-3 border-red-200 bg-red-50/50 text-red-800">
                            <p className="text-sm font-semibold mb-3">
                                {t("label_accion_rechazar_x")}
                            </p>
                            {renderNotificacionFields("rechazar")}
                        </div>
                    </div>

                    <div className="flex justify-end mt-6">
                        <button
                            type="button"
                            className={ESTILO_BOTON_MODAL_CANCELAR}
                            onClick={onCancel}
                        >
                            {t("label_cancelar")}
                        </button>
                        <button
                            type="button"
                            className={ESTILO_BOTON_MODAL_ACEPTAR}
                            onClick={() => onSave(normalizarConfigAccionesKanban(config))}
                        >
                            {t("label_guardar")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
